"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _lodash = _interopRequireDefault(require("lodash.uniqby"));
var _services = require("../../../../services");
var _constants = require("../../../../utils/constants");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var BusinessSolutionValueText = _styledComponents.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-weight: bold;\n  margin-right: 5px;\n"])));
var BusinessSolutionCardInfo = function BusinessSolutionCardInfo(_ref) {
  var businessSolution = _ref.businessSolution;
  var hideSpecIds = ['longDescription', 'businessSolutionUrl', 'description'];
  var groupPriority = {
    advantages: 1,
    features: 2,
    bulletFeatures: 3
  };
  var FEATURE_WITHOUT_NAME = 'bulletFeatures';
  var characteristics = (0, _lodash.default)(businessSolution.selectedVariant.characteristics, function (c) {
    var _c$value$;
    return (_c$value$ = c.value[0]) === null || _c$value$ === void 0 ? void 0 : _c$value$.value;
  }).filter(function (c) {
    return !hideSpecIds.includes(c.id);
  }).sort(function (a, b) {
    var groupPriorityA = Math.min.apply(Math, _toConsumableArray(a.groups.map(function (group) {
      return groupPriority[group];
    })));
    var groupPriorityB = Math.min.apply(Math, _toConsumableArray(b.groups.map(function (group) {
      return groupPriority[group];
    })));
    return groupPriorityA - groupPriorityB;
  });
  var parseSpecValue = function parseSpecValue(spec) {
    var specValues = spec.value.map(function (val) {
      return val.value >= _constants.UNLIMITED_VALUE ? _services.locale.localeString('Recommendation.BroadbandUnlimited') : val.value;
    });
    var isAllBooleans = specValues.every(function (val) {
      return typeof val === 'boolean';
    });
    return isAllBooleans ? specValues.every(Boolean) : specValues.join(', ');
  };
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement("ul", null, characteristics.map(function (spec, index) {
    var valueText = parseSpecValue(spec);
    if (!valueText) return null;
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
      spacing: 1,
      verticalAlign: "center"
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, !spec.groups.includes(FEATURE_WITHOUT_NAME) && /*#__PURE__*/_react.default.createElement(BusinessSolutionValueText, null, spec.name), valueText)), index < characteristics.length - 1 && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null));
  })));
};
var _default = BusinessSolutionCardInfo;
exports.default = _default;